class Department {
  constructor(params) {
    this.id = params.id;
    this.name = params.name;
  }
}

export { Department };



// WEBPACK FOOTER //
// ./src/models/Department.js